import React from 'react'
import { constants } from 'common/helpers'

import s from './Title.scss'


const Title = ({ title, withMicrodata }) => (
  <div
    className={s.title}
    {...withMicrodata && { itemProp: 'name' }}
    data-testid={constants.testIds.review.title}
  >
    {title}
  </div>
)


export default Title
